export enum TipoPreviaMensagemEnum {
  TEXTO = 'TEXTO',
  FOTO = 'FOTO',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  FIGURINHA = 'FIGURINHA',
  DOCUMENTO = 'DOCUMENTO',
  REACAO = 'REACAO',
  TEMPLATE = 'TEMPLATE',
  DISPARO = 'DISPARO'
}
